import React, { useEffect, useState } from "react";
import showAlert from "../../../server/ShowAlert";
import { updateProductFields } from "../../../server/Product";
import { useDispatch, useSelector } from "react-redux";
import { setPreload } from "../../../server/CartsOpen";
import { X } from "lucide-react";
import * as actionType from "../../../store/action";

const parseNonNegativeNumber = (raw, { integer = false, label }) => {
  if (raw === "" || raw === null || raw === undefined) {
    return { error: `יש להזין ${label}` };
  }

  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return { error: `${label} אינו תקין` };
  }
  if (n < 0) {
    return { error: `${label} לא יכול להיות שלילי` };
  }
  if (integer && !Number.isInteger(n)) {
    return { error: `${label} חייב להיות מספר שלם` };
  }

  return { value: n };
};

const ProductDetailsPopUp = ({
  product: productProp,
  CloseProductDetails,
  onProductUpdated,
}) => {
  const dispatch = useDispatch();
  const [masterCartonQuantity, setMasterCartonQuantity] = useState("");
  const [manufacturerPackQuantity, setManufacturerPackQuantity] = useState("");

  const { selectedProduct, stationId } = useSelector((state) => ({
    selectedProduct: state.selectedProduct.product,
    stationId: state.user.stationId,
  }));

  const product = productProp || selectedProduct;

  useEffect(() => {
    if (!product) return;

    setMasterCartonQuantity(
      product.logisticsDetails?.masterCartonQuantity ?? "",
    );
    setManufacturerPackQuantity(
      product.logisticsDetails?.manufacturerPackQuantity ?? "",
    );
  }, [product]);

  const handleSave = () => {
    if (!product?.productId) {
      showAlert({ msgTitle: "לא נמצא מוצר לעדכון", msgType: "error" });
      return;
    }

    const carton = parseNonNegativeNumber(masterCartonQuantity, {
      integer: true,
      label: "כמות בארגז",
    });
    const pack = parseNonNegativeNumber(manufacturerPackQuantity, {
      integer: true,
      label: "כמות במארז יצרן",
    });

    const firstError = carton.error || pack.error;
    if (firstError) {
      showAlert({ msgTitle: firstError, msgType: "error" });
      return;
    }

    const fields = {
      "logisticsDetails.masterCartonQuantity": carton.value,
      "logisticsDetails.manufacturerPackQuantity": pack.value,
    };

    dispatch(setPreload(true));
    updateProductFields(stationId, product.productId, fields)
      .then((response) => {
        if (response?.data) {
          const updatedProduct = {
            ...product,
            logisticsDetails: {
              ...product.logisticsDetails,
              masterCartonQuantity: carton.value,
              manufacturerPackQuantity: pack.value,
            },
          };

          dispatch({
            type: actionType.SET_SELCTED_PRODUCT,
            data: { Product: updatedProduct },
          });
          onProductUpdated?.(updatedProduct);

          showAlert({ msgTitle: "השינויים נשמרו בהצלחה", msgType: "success" });
          CloseProductDetails();
        } else {
          showAlert({ msgTitle: "השינויים לא נשמרו", msgType: "error" });
        }
      })
      .catch(() =>
        showAlert({ msgTitle: "שגיאה בחיבור לרשת", msgType: "error" }),
      )
      .finally(() => dispatch(setPreload(false)));
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      CloseProductDetails();
    }
  };

  return (
    <div
      className="product-detail-overlay"
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className="product-detail"
        role="dialog"
        aria-modal="true"
        aria-labelledby="product-detail-title"
      >
        <div className="product-detail__header">
          <h3 id="product-detail-title" className="product-detail__title">
            פרטי מוצר
          </h3>
          <button
            type="button"
            className="product-detail__close"
            onClick={CloseProductDetails}
            aria-label="סגור"
          >
            <X size={20} strokeWidth={2} />
          </button>
        </div>

        <div className="product-detail__fields">
          <label className="product-detail__field">
            <span className="product-detail__label">כמות בארגז</span>
            <input
              type="number"
              min={0}
              step={1}
              value={masterCartonQuantity}
              onChange={(e) => setMasterCartonQuantity(e.target.value)}
            />
          </label>

          <label className="product-detail__field">
            <span className="product-detail__label">כמות במארז יצרן</span>
            <input
              type="number"
              min={0}
              step={1}
              value={manufacturerPackQuantity}
              onChange={(e) => setManufacturerPackQuantity(e.target.value)}
            />
          </label>
        </div>

        <div className="product-detail__actions">
          <button
            type="button"
            className="product-detail__save"
            onClick={handleSave}
          >
            שמור
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPopUp;
